import React from 'react';
import Head from 'next/head';
import {
  CRELLIN_CALENDAR_PATH,
  FFH_HOSTNAME,
  WEBSITE_NAME
} from '../../lib/constants';

import FeaturePanel from '../../components/panel/feature';
import { H1 } from '../../components/atoms/typography';
import Icon from '../../components/atoms/icon';
import Layout from '../../components/layout';
import Title from '../../components/title';

const Tools = () => (
  <div>
    <Head>
      {/* Single child: next/head drops a <title> with array children. */}
      <title>{`Tools | ${WEBSITE_NAME}`}</title>
      <meta
        name="description"
        content="Every Fantasy Football Hub tool in one place: predicted points, player profiles, fixture ticker, OPTA stats, price change predictions and more."
        key="description"
      />
      <link rel="canonical" href={`${FFH_HOSTNAME}/tools`} key="canonical" />
    </Head>
    <Title>Tools</Title>
    <Layout>
      <div className="relative px-4 pt-8 pb-20 sm:px-6 lg:pb-10 lg:px-8">
        <div className="absolute inset-0">
          <div className="bg-white h-1/3 sm:h-2/3" />
        </div>
        <div className="text-center">
          <H1 className="text-center">{'Select a tool'}</H1>
        </div>
        <div className="relative mx-auto max-w-7xl pb-14">
          <div className="m-3">
            <ul className="w-full mt-2 mb-3 text-blue-800 rounded-lg">
              <div className="hidden sm:block">
                <FeaturePanel
                  headline="My Team"
                  description="Optimise, monitor and manage your FPL team with customised tips"
                  link="/my-team"
                >
                  <Icon name={'Trophy'} style={{ fontSize: 40 }} />
                </FeaturePanel>
              </div>
              <FeaturePanel
                headline="Opta"
                description="The go-to place for all the latest fantasy football statistics"
                link="/opta"
              >
                <Icon name={'BarChart'} style={{ fontSize: 40 }} />
              </FeaturePanel>
              <FeaturePanel
                headline="Player Points Predictions"
                description="Our predicted player points for every gameweek"
                link="/predictions"
              >
                <Icon name={'LineGraph'} style={{ fontSize: 40 }} />
              </FeaturePanel>
              <FeaturePanel
                headline="Fixture Ticker"
                description="A good fixture ticker should be every manager’s best friend"
                link="/fixture-ticker"
              >
                <Icon name={'Calendar'} style={{ fontSize: 40 }} />
              </FeaturePanel>
              <FeaturePanel
                headline="Price Changes"
                description="Price change predictor to plan your next transfers"
                link="/fantasy-premier-league-price-rises"
              >
                <Icon name={'ArrowSortFilled'} style={{ fontSize: 40 }} />
              </FeaturePanel>
              <FeaturePanel
                headline="Player Comparisons"
                description="Debating between players for your fantasy team?"
                link="/fpl-player-comparison-tool"
              >
                <Icon name={'Group'} style={{ fontSize: 40 }} />
              </FeaturePanel>
              <FeaturePanel
                headline="Player Profile"
                description="Search for statistics and heatmaps on a single player"
                link="/player-profile"
              >
                <Icon name={'PersonRunningFilled'} style={{ fontSize: 40 }} />
              </FeaturePanel>
              <FeaturePanel
                headline="Ben Crellin's FPL Calendar"
                description="Ben Crellin's Fixture Calendar Sheet"
                link={CRELLIN_CALENDAR_PATH}
              >
                <Icon name={'Calendar'} style={{ fontSize: 40 }} />
              </FeaturePanel>
              <FeaturePanel
                headline="Ben Crellin's planner"
                description="The only transfer planner spreadsheet you need"
                link="/ben-crellins-fpl-transfer-planning-sheet"
              >
                <Icon name={'ListAlt'} style={{ fontSize: 40 }} />
              </FeaturePanel>
              <FeaturePanel
                headline="Jossy's planner"
                description="Jossy's clever FPL planning sheet has a number of key tools to help fantasy managers"
                link="/jossys-fpl-planner"
              >
                <Icon name={'ListAlt'} style={{ fontSize: 40 }} />
              </FeaturePanel>
              <FeaturePanel
                headline="Match Centre"
                description="View FPL scores update live"
                link="/fpl-match-centre"
              >
                <Icon name={'SoccerBall'} style={{ fontSize: 40 }} />
              </FeaturePanel>
              <FeaturePanel
                headline="Live Rank"
                description="Check your FPL Live Rank at any time here using your FPL ID"
                link="/my-team/points"
              >
                <Icon name={'ShowChart'} style={{ fontSize: 40 }} />
              </FeaturePanel>
            </ul>
          </div>
        </div>
      </div>
    </Layout>
  </div>
);

export default Tools;
